<kendo-card>
  <kendo-card-body>
    <div class="header">
      <h2>{{ 'mobile_info.title' | localize }}</h2>
      <hr kendoCardSeparator />
      <div class="text-content">
        <h5>
          {{ 'mobile_info.main' | localize }}
          <p></p>
          {{ 'mobile_info.list.0' | localize }}
          <ul>
            <li>{{ 'mobile_info.list.1' | localize }}</li>
            <li>{{ 'mobile_info.list.2' | localize }}</li>
            <li>{{ 'mobile_info.list.3' | localize }}</li>
            <li>{{ 'mobile_info.list.4' | localize }}</li>
            <li>{{ 'mobile_info.list.5' | localize }}</li>
            <li>{{ 'mobile_info.list.6' | localize }}</li>
            <li>{{ 'mobile_info.list.7' | localize }}</li>
          </ul>
        </h5>
      </div>
      <div class="download-links">
        <img class="qrcode" [attr.src]="qrAppstoreImage" />
        <button kendoButton [primary]="true" (click)="goToAppStore()" class="app-store"></button>
        <img class="qrcode" [attr.src]="qrPlayMarketImage" />
        <button
          kendoButton
          [primary]="true"
          class="manual-load"
          iconClass="fab fa-android"
          (click)="goToPlayMarket()"
        ></button>
      </div>
    </div>

    <kendo-scrollview kendoCardMedia [data]="images" [arrows]="true" [pageable]="true">
      <ng-template let-item="item">
        <img
          *ngIf="item.url"
          src="{{ item.url }}"
          alt="{{ item.title }}"
          [ngStyle]="{ width: '100%', height: '100%' }"
          draggable="false"
        />
      </ng-template>
    </kendo-scrollview>
  </kendo-card-body>
</kendo-card>
